import { Lookup, useLookup } from '@/providers'
import { RHFAutocomplete, RHFFieldArray, RHFTextField } from '@components/RHFInputs'
import { Divider, MenuItem, Stack, Typography } from '@mui/material'
import { useMarketBasketContext } from '@views/MarketBaskets/MarketBaskets.hooks'

import { ManualExclusionSchema } from './BasketExclusions.schema'

/**
 * Manual basket exclusions form
 */
export default function ManualExclusionsForm() {
	const programTypes = useLookup(Lookup.ProgramTypes)
	const { marketBasket } = useMarketBasketContext()

	return (
		<Stack spacing={2}>
			<Typography variant="h6">Manual</Typography>
			<Divider />
			<RHFFieldArray<ManualExclusionSchema>
				defaultValue={{ manufacturer: null, program: null, customer: null }}
				name="manualExclusions"
				addButtonLabel="Add Exclusion"
				spacing={2}
				renderField={({ fieldName }) => (
					<Stack width="100%" direction="row" spacing={2} sx={{ alignItems: 'center' }}>
						<RHFAutocomplete.Manufacturer
							size="small"
							fullWidth
							name={fieldName('manufacturer')}
							label="Manufacturer"
							required
						/>
						<RHFAutocomplete.BasketCustomer
							size="small"
							fullWidth
							name={fieldName('customer')}
							label="Customer"
							marketBasketId={marketBasket.id}
							required
						/>
						<RHFTextField
							name={fieldName('program')}
							select
							size="small"
							label="Program Type"
							fullWidth
							required
						>
							{programTypes.map((program) => (
								<MenuItem key={program.id} value={program.id}>
									{program.label}
								</MenuItem>
							))}
						</RHFTextField>
					</Stack>
				)}
			/>
		</Stack>
	)
}
